function getSystemPrefersDark() {
    return window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
}
function getStoredTheme() {
    try {
        const value = localStorage.getItem('theme');
        console.log('[theme] getStoredTheme', { value });
        return value === 'dark' || value === 'light' ? value : null;
    }
    catch {
        console.log('[theme] getStoredTheme error: localStorage not available');
        return null;
    }
}
function applyTheme(theme) {
    const root = document.documentElement;
    console.log('[theme] applyTheme →', theme, 'before:', root.className);
    if (theme === 'dark') {
        root.classList.add('dark');
    }
    else {
        root.classList.remove('dark');
    }
    console.log('[theme] applyTheme done. after:', root.className);
}
function setTheme(theme) {
    applyTheme(theme);
    try {
        localStorage.setItem('theme', theme);
        console.log('[theme] setTheme persisted', { theme });
    }
    catch {
        console.log('[theme] setTheme persist error: localStorage not available');
    }
}
// Apply theme immediately to prevent flash of unstyled content
function applyThemeImmediately() {
    try {
        const stored = getStoredTheme();
        const prefers = getSystemPrefersDark();
        const initial = stored ?? (prefers ? 'dark' : 'light');
        applyTheme(initial);
    }
    catch (e) {
        console.log('[theme] applyThemeImmediately error:', e);
    }
}
// Apply theme immediately when script loads
applyThemeImmediately();
export function initializeTheme() {
    const toggleButton = document.getElementById('theme-toggle');
    const iconMoon = document.getElementById('icon-moon');
    const iconSun = document.getElementById('icon-sun');
    if (!toggleButton) {
        console.log('[theme] initializeThemeToggle: button not found');
        return;
    }
    console.log('[theme] initializeThemeToggle: button found');
    // Initialize from storage or system
    const stored = getStoredTheme();
    const prefers = getSystemPrefersDark();
    const initial = stored ?? (prefers ? 'dark' : 'light');
    console.log('[theme] initial calculation', { stored, prefers, initial });
    applyTheme(initial);
    const isDarkInitial = document.documentElement.classList.contains('dark');
    toggleButton.setAttribute('aria-pressed', isDarkInitial ? 'true' : 'false');
    toggleButton.setAttribute('aria-label', isDarkInitial ? 'Switch to light mode' : 'Switch to dark mode');
    // Sync icons
    if (iconMoon && iconSun) {
        if (isDarkInitial) {
            iconMoon.classList.add('hidden');
            iconSun.classList.remove('hidden');
        }
        else {
            iconMoon.classList.remove('hidden');
            iconSun.classList.add('hidden');
        }
    }
    // Toggle on click
    toggleButton.addEventListener('click', () => {
        const isDark = document.documentElement.classList.contains('dark');
        const next = isDark ? 'light' : 'dark';
        console.log('[theme] toggle click', { isDark, next });
        // Remove any inline class from early script to ensure fresh application
        const root = document.documentElement;
        root.classList.remove('dark');
        setTheme(next);
        const newIsDark = !isDark;
        toggleButton.setAttribute('aria-pressed', newIsDark ? 'true' : 'false');
        toggleButton.setAttribute('aria-label', newIsDark ? 'Switch to light mode' : 'Switch to dark mode');
        if (iconMoon && iconSun) {
            if (newIsDark) {
                iconMoon.classList.add('hidden');
                iconSun.classList.remove('hidden');
            }
            else {
                iconMoon.classList.remove('hidden');
                iconSun.classList.add('hidden');
            }
        }
    });
    // React to system changes if user hasn't explicitly chosen
    const media = window.matchMedia('(prefers-color-scheme: dark)');
    const onChange = () => {
        if (!getStoredTheme()) {
            const next = media.matches ? 'dark' : 'light';
            console.log('[theme] system preference changed →', next);
            applyTheme(next);
            toggleButton.setAttribute('aria-pressed', media.matches ? 'true' : 'false');
            toggleButton.setAttribute('aria-label', media.matches ? 'Switch to light mode' : 'Switch to dark mode');
            if (iconMoon && iconSun) {
                if (media.matches) {
                    iconMoon.classList.add('hidden');
                    iconSun.classList.remove('hidden');
                }
                else {
                    iconMoon.classList.remove('hidden');
                    iconSun.classList.add('hidden');
                }
            }
        }
    };
    media.addEventListener('change', onChange);
}
